import { useContext } from "react";

import StyledButton from "../components/StyledButton";
import { LangContext } from "../contexts/langContext";
import { SelectAnswerContext } from "../contexts/selectAnswerContext";
import { getButtonPalletFromCorrectOrIncorrect } from "../util/getButtonPalletFromCorrectOrIncorrect";
import useShowingCorrectAnswer from "../hooks/useShowingCorrectAnswer";
import { ImageIsScamOrNotProps } from "@common";
import useIsMinimizedQuiz from "@natklok/hooks/useIsMinimizedQuiz";
import ConditionalWrapper from "@natklok/components/ConditionalWrapper";
import { AlignCenter } from "@natklok/components";

interface RenderProps extends ImageIsScamOrNotProps {
  readOnly?: boolean;
  showCorrect?: boolean;
}

const ImageIsScamOrNot: React.FC<{
  [key in keyof RenderProps]: RenderProps[key];
}> = ({
  imageSrc,
  leftButtonText,
  leftButtonIsCorrect,
  rightButtonText,
  rightButtonIsCorrect,
  readOnly = false,
  showCorrect = false,
}) => {
  const { translateTranslationData } = useContext(LangContext);
  const { onSelectAnswer } = useContext(SelectAnswerContext);
  const showingCorrectAnswer = useShowingCorrectAnswer();
  const minimized = useIsMinimizedQuiz();
  const displayCorrectAnswers = showCorrect || showingCorrectAnswer;

  return (
    <ConditionalWrapper
      condition={minimized}
      wrapper={(children: any) => <AlignCenter withMaxWidth>{children}</AlignCenter>}
    >
      <img src={imageSrc} style={{ width: "100%", height: "100%" }} alt={imageSrc} />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          paddingTop: 8,
          width: "100%",
        }}
      >
        <StyledButton
          hasCooldown
          disabled={readOnly}
          onClick={() =>
            onSelectAnswer(leftButtonIsCorrect, {
              val1: 0,
              val2: leftButtonIsCorrect === "correct" ? 1 : 0,
              val3: leftButtonIsCorrect === "incorrect" ? 1 : 0,
            })
          }
          fullWidth
          style={{
            maxWidth: "13em",
            margin: 0,
          }}
          label={translateTranslationData(leftButtonText)}
          clickable={displayCorrectAnswers === false}
          palette={getButtonPalletFromCorrectOrIncorrect(
            displayCorrectAnswers,
            leftButtonIsCorrect
          )}
        />
        <StyledButton
          hasCooldown
          disabled={readOnly}
          onClick={() =>
            onSelectAnswer(rightButtonIsCorrect, {
              val1: 0,
              val2: rightButtonIsCorrect === "correct" ? 1 : 0,
              val3: rightButtonIsCorrect === "incorrect" ? 1 : 0,
            })
          }
          fullWidth
          style={{
            maxWidth: "13em",
            margin: 0,
          }}
          label={translateTranslationData(rightButtonText)}
          clickable={displayCorrectAnswers === false}
          palette={getButtonPalletFromCorrectOrIncorrect(
            displayCorrectAnswers,
            rightButtonIsCorrect
          )}
        />
      </div>
    </ConditionalWrapper>
  );
};

export default ImageIsScamOrNot;
